export const getInventoryIntraBranchList = state => {
    return state.list
}

export const getInventoryIntraBranchDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryIntraBranch/getters.js